import { PAGINATION_LIMIT } from '@constants/generic';

import { FormListItem, GetFormsParams } from '../types';
import { FormListApiResponse } from '../types/formListApi';
import { mapFormListItemToApi } from './mapFormListItemToApi';

const sortItems = (
  items: FormListItem[],
  sortBy: GetFormsParams['sortBy'],
  sortOrder: GetFormsParams['sortOrder']
): FormListItem[] => {
  const order = sortOrder ?? 'desc';
  const sorted = [...items];

  if (
    sortBy === 'name' ||
    sortBy === 'registrationCount' ||
    sortBy === 'conversionRate'
  ) {
    sorted.sort((a, b) => {
      const aVal = a[sortBy];
      const bVal = b[sortBy];
      if (typeof aVal === 'string' && typeof bVal === 'string') {
        return order === 'asc'
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
      }
      if (typeof aVal === 'number' && typeof bVal === 'number') {
        return order === 'asc' ? aVal - bVal : bVal - aVal;
      }
      return 0;
    });
    return sorted;
  }

  sorted.sort(
    (a, b) =>
      new Date(b.lastEdited).getTime() - new Date(a.lastEdited).getTime()
  );
  return sorted;
};

export const filterMockFormsList = (
  items: FormListItem[],
  params: GetFormsParams
): FormListApiResponse => {
  const page = params.page ?? 0;
  const limit = params.limit ?? PAGINATION_LIMIT;
  const search = params.search?.trim()?.toLowerCase() || '';

  let filtered = [...items];

  if (params.status?.length) {
    filtered = filtered.filter((item) => params.status?.includes(item.status));
  }

  if (params.addTo?.length) {
    filtered = filtered.filter((item) =>
      params.addTo?.includes(item.addTo.mode)
    );
  }

  if (search) {
    filtered = filtered.filter((item) =>
      (item.name?.toLowerCase() || '').includes(search)
    );
  }

  filtered = sortItems(filtered, params.sortBy, params.sortOrder);

  const totalRows = filtered.length;
  const start = page * limit;
  const pageItems = filtered.slice(start, start + limit);

  return {
    data: pageItems.map(mapFormListItemToApi),
    pagination: {
      page,
      limit,
      total_rows: totalRows,
      last_page: start + limit >= totalRows
    }
  };
};

export default filterMockFormsList;
